/* eslint-env browser */
import Vue from "vue";
import { mapGetters } from "vuex";

Vue.component("notification-component", {
  props: ["notificationData"],
  template: `<div class="c-notification" v-bind:class="cClass">
                <div class="c-notification__content">
                  <div class="c-notification__close" v-if="notificationData.closeButton" v-on:click="close">&times;</div>
                  <div class="c-notification__title" v-if="notificationData.title" v-html="notificationData.title"></div>
                  <div v-if="notificationData.type === 'welcome'" style="padding:56.25% 0 0 0;position:relative;">
                    <iframe src="https://player.vimeo.com/video/269867331?autoplay=0&color=ffffff&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                  </div>
                  <div class="c-notification__message" v-html="notificationData.content"></div>
                  <div class="c-notification__footer" v-html="notificationData.footer"></div>
                  
                  <div class="c-notification__games" v-if="!getIsMobile && desktopGames" >  
                     <a v-for="game in desktopGames" v-bind:href="gameUrl+game">
                        <img v-bind:src="'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/'+game+'.jpg'">
                      </a>
                  </div>

                  <div class="c-notification__games" v-if="getIsMobile && mobileGames">  
                      <a v-for="game in mobileGames" v-bind:href="gameUrl+game">
                        <img v-bind:src="'https://casino.partyaccount.com/htmllobby/images/newlmticons/square/'+game+'.jpg'">
                      </a>
                  </div>

                  <div class="c-notification__games">
                  
                    <div v-if="notificationData.action.text !== ''">

                      <a v-if="notificationData.type === 'welcome'" class="btn prominent btn-l3 btn--margin-top" v-on:click="close">{{ notificationData.action.text }}</a>

                      <a v-on:click="ctaTracking" class="btn prominent btn-l3 btn--margin-top"
                        v-if="notificationData.action && notificationData.type !== 'welcome' && !getIsNative"
                        v-bind:href="notificationData.action.url"
                      >{{ notificationData.action.text }}</a>

                      <a v-on:click="ctaTracking" class="btn prominent btn-l3 btn--margin-top"
                        v-if="notificationData.action && notificationData.type !== 'welcome' && getIsNative"
                        v-bind:href="notificationData.action.native"
                      >{{ notificationData.action.text }}</a>

                    </div>

                  </div>

              </div>
            </div>`,
  computed: {
    ...mapGetters(["getIsMobile", "getIsNative", "getLanguage"]),
    cClass() {
      return `c-notification__${this.notificationData.type}`;
    },
    desktopGames() {
      if (this.notificationData.gameCodeDesktop) {
        return this.notificationData.gameCodeDesktop.split(',');
      }
      return false;
    },
    mobileGames() {
      if (this.notificationData.gameCodeMobile) {
        return this.notificationData.gameCodeMobile.split(',');
      }
      return false;
    },
    gameUrl() {
      return clientConfig.lhProductHomepages.casino+'/games/launchng/';   
    }
  },
  methods: {
    close() {
      const self = this;
      self.$emit("close");
      dataLayer.push({
        event: "Event.Functionality.",
        "page.referringAction": `coin-flip_${
          this.notificationData.type
        }Message_Close`
      });
    },
    ctaTracking() {
      dataLayer.push({
        event: "Event.Functionality.",
        "page.referringAction": `coin-flip_${
          this.notificationData.type
        }_CTA_Clicked`
      });
    },
    getDevice() {
      if (this.getIsNative) return "native";
      if (this.getIsMobile) return "mobile";

      return "desktop";
    },
  },
 
  mounted() {
    const self = this;
    if (!this.notificationData.stayOpen) {
      setTimeout(self.close, this.notificationData.duration);
    }
  }
});
 


// WEBPACK FOOTER //
// ./app/js/components/notifications/notification-component.js